export enum GetRewardStep {
}

export function getRewardStepTitle(): string | undefined {
        return 'GetReward.info.title'
}

export function getRewardDoneButtonTitle(): string {
        return 'GetReward.info.done'
}
